// Constants for different requests for current reducer
export default {
  statPerDate: 'STAT_PER_DATE',
};
